/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ReturnFocusTo, State } from './ReturnFocusTo.types.tsx';

export const getReturnFocusTo = (state: State): ReturnFocusTo | null => state.returnFocusTo;
